/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const Toast = ({ children, title, status, extraClass, position, remove }) => {
  const removeRef = useRef();
  removeRef.current = remove;

  useEffect(() => {
    const duration = 5_000;
    const id = setTimeout(() => removeRef.current(), duration);

    return () => clearTimeout(id);
  }, []);

  return (
    <div
      aria-live="polite"
      className={`toast ${position} ${status} ${extraClass}`}
      onClick={remove}
      onKeyDown={remove}
      role="alert"
    >
      {title && <p className="toast__title">{title}</p>}
      <div className="toast__image" />
      <p className="toast__message">{children}</p>
    </div>
  );
};

Toast.propTypes = {
  children: PropTypes.node,
  extraClass: PropTypes.string,
  position: PropTypes.oneOf([
    'top-right',
    'top-left',
    'bottom-right',
    'bottom-left',
  ]),
  remove: PropTypes.func,
  status: PropTypes.oneOf([
    'toast-error',
    'toast-info',
    'toast-success',
    'toast-warning',
  ]),
  title: PropTypes.string,
};

Toast.defaultProps = {
  extraClass: '',
  position: 'top-right',
  status: 'toast-info',
  title: '',
};

export default Toast;
